import { PWA_SHELL_STORAGE } from "./config";
import { isStandalone } from "./isStandalone";

export const hasInstalledMarker = () => {
	try {
		const raw = localStorage.getItem(PWA_SHELL_STORAGE.installed);
		if (!raw) return false;
		const parsed = JSON.parse(raw);
		return Boolean(parsed?.installed || parsed?.accepted);
	} catch {
		return false;
	}
};

/**
 * Best-effort: Chrome Android can report related web apps.
 * Requires related_applications in the manifest.
 */
export const getInstalledRelatedWebApps = async () => {
	if (typeof navigator === "undefined" || !navigator.getInstalledRelatedApps) {
		return [];
	}
	try {
		return await navigator.getInstalledRelatedApps();
	} catch {
		return [];
	}
};

/**
 * True when we believe the shell PWA is already installed.
 * Note: browsers cannot always prove this from a normal tab.
 * If beforeinstallprompt is available, prefer showing Install instead.
 */
export const resolveInstalledState = async ({ installPromptAvailable } = {}) => {
	if (isStandalone()) return true;
	if (installPromptAvailable) return false;

	if (hasInstalledMarker()) return true;

	const related = await getInstalledRelatedWebApps();
	return Array.isArray(related) && related.length > 0;
};
